import { useAtomValue } from 'jotai';

import checkPhoneBg from '@/assets/login/check_modal_head.webp';
import Button from '@/components/button';
import { IconUpgrade } from '@/components/icons/icons';
import BlurryLoadingImage from '@/components/progressive-img';
import { userStateAtom } from '@/jotai/user';

import styles from './styles.module.less';

const CheckPhoneModal = (modal: any, onClose, data) => {
  const userState = useAtomValue(userStateAtom);
  return (
    <div className={styles.check_box}>
      <div className={styles['img_checkbox']}>
        <BlurryLoadingImage loading="lazy" src={checkPhoneBg} alt="" />
      </div>
      <div className={styles.main}>
        <div className={styles.header}>
          <div className={styles.header_title}>WARNING</div>
          <div className={styles.header_content}>
            Your phone number <span>{data?.mobile}</span> is being
            <br /> bound to a new account.
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.content_left}>
            <div className={styles.content_title}>Old</div>
            <div className={styles.content_item}>ID:{data?.userid}</div>
            <div className={styles.content_item}>VIP{data?.viplevel}</div>
          </div>
          <div style={{ width: '0.54rem', flex: 'none' }}>
            <IconUpgrade style={{ width: '0.28rem', height: 'fit-content', color: '#79838e', flex: 'none' }} />
          </div>
          <div className={styles.content_right}>
            <div className={styles.content_title}>New</div>
            <div className={styles.content_item}>ID:{userState?.userid}</div>
            <div className={styles.content_item}>VIP{userState?.viplevel}</div>
          </div>
        </div>
        <div className={styles.hint_text}>The old account will be deleted</div>
        <div className={styles.content_button}>
          <Button
            onClick={() => {
              modal.resolve({
                confirm: true,
                onClose
              });
            }}
          >
            Bind
          </Button>
          <Button
            onClick={() => {
              modal.resolve({
                confirm: false,
                onClose
              });
            }}
            className={styles.button_cancel}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CheckPhoneModal;
